(function(){
"use strict";

const fmt = n => "$" + n.toLocaleString("es-CL");
// Precios copiados de Kaching el 17-10 (en la versión final salen de Kaching o de metacampos)
const PACKS = [
  {id: "p1", name: "1 Bundle", short: "1 Bundle", days: 60, perDay: 772, price: 46314, was: 55800, free: true, tag: null},
  {id: "p2", name: "2 Bundles", short: "2 Bundles", days: 120, perDay: 725, price: 87048, was: 111600, free: true, tag: null},
  {id: "p3", name: "3 Bundles", short: "3 Bundles", days: 180, perDay: 698, price: 125550, was: 167400, free: true, tag: null}
];
const pk = id => PACKS.find(x => x.id === id);
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const buyEl = () => document.querySelector("kaching-bundle") || document.querySelector(".product-form") || document.querySelector(".product__info-container");
const go = () => { const b = buyEl(); if (b) b.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); };
function pickK(id){
  const i = {p1:0, p2:1, p3:2}[id];
  const bars = [...document.querySelectorAll("kaching-bundle .kaching-bundles__bar")].filter(b => !b.classList.contains("kaching-bundles__checkbox-upsells__upsell"));
  if (bars[i]) bars[i].click();
  go();
}
function render(){
  document.querySelectorAll("[data-strip]").forEach(el => {
    el.innerHTML = PACKS.map(p => `<button class="spt" role="radio" aria-checked="false" data-id="${p.id}">
      ${p.tag ? `<span class="tg">${p.tag}</span>` : ""}
      <b>${p.name}</b><span class="pr num">${fmt(p.price)}</span><span class="pd num">${fmt(p.perDay)} al día</span>
      <span class="sh">${p.free ? "Despacho gratis" : "Despacho aparte"}</span></button>`).join("");
  });
  const sr = document.getElementById("sRows");
  if (sr) sr.innerHTML = [pk("p1"), pk("p3")].map(r => `<span class="s-row ${r.id==="p3" ? "hi" : ""}"><span class="n">${r.short}</span><b class="num">${fmt(r.perDay)}/día</b><span class="num">${fmt(r.price)}</span></span>`).join("");
}
document.addEventListener("click", e => {
  const sb = e.target.closest(".lp .spt"); if (sb) { pickK(sb.dataset.id); return; }
  const dp = e.target.closest(".lp [data-pick]"); if (dp) { pickK(dp.dataset.pick); return; }
  if (e.target.closest("#sBtn")) go();
});
render();
// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  // Feriados irrenunciables (Ley 19.973): ese día no hay despacho, pasa al día siguiente
  const FER = ["2026-01-01","2026-05-01","2026-09-18","2026-09-19","2026-12-25","2027-01-01","2027-05-01","2027-09-18","2027-09-19","2027-12-25"];
  const ymd = x => x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0");
  let k = h >= 12 ? 1 : 0;
  d.setDate(d.getDate() + k);
  while (FER.includes(ymd(d))) { d.setDate(d.getDate() + 1); k++; }
  const txt = `Llega ${k === 0 ? "hoy" : k === 1 ? "mañana" : "el"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Etiqueta
const lm = document.getElementById("labelModal"); let lastFocus = null;
if (lm) {
  document.querySelectorAll("[data-label]").forEach(b => b.addEventListener("click", () => { lastFocus = b; lm.hidden = false; document.getElementById("labelClose").focus(); }));
  const closeLm = () => { lm.hidden = true; if (lastFocus) lastFocus.focus(); };
  document.getElementById("labelClose").addEventListener("click", closeLm);
  lm.addEventListener("click", e => { if (e.target === lm) closeLm(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !lm.hidden) closeLm(); });
}
if (reduce) document.querySelectorAll(".lp video").forEach(v => { v.removeAttribute("autoplay"); v.pause(); });

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("video").forEach(v => { const im = document.createElement("img"); im.className = "vposter"; im.src = (s.querySelector("video") || {}).poster || ""; im.alt = ""; v.replaceWith(im); });
    c.querySelectorAll("button,[data-label]").forEach(x => { x.removeAttribute("data-label"); x.setAttribute("tabindex", "-1"); });
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();